// /**
//  * Parcels details - list
//  */

// React
import React from 'react';

// UI
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  IconButton,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiCheckBoxOutline,
  mdiSquareOutline,
  mdiFileTree,
} from '@mdi/js';

// Helper
import {
  checkMatchMedia, translate,
} from '../../utils/helpers';

// Type
import { Product } from './interfaces';
import theme from '../../theme';

type Props = {
  handleOpenConfirmDisable: (product: Product) => void;
  setOpenBarcode: (product: Product) => void;
  data: any;
  operatorId: number;
};

// Style
const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:nth-of-type(even)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }),
)(TableRow);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& .MuiTableCell-root': {
        padding: '5px',
      },
    },
    paper: {
      width: '100%',
    },
    table: {
      // minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    textArea: {
      width: '100%',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    columnText: {
      padding: '0 10px',
    },
    container: {
      // maxHeight: 540,
      borderRadius: '4px',
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
  }),
);

export default function EnhancedTable(props: Props) {
  const classes = useStyles();
  const { handleOpenConfirmDisable, setOpenBarcode } = props;

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer className={classes.container}>
          <Table
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            size={checkMatchMedia('(max-width: 1024px)') ? 'small' : 'medium'}
            aria-label="enhanced table"
          >


            <TableBody>
              {props.data
                .map((row: any, index: number) => {
                  const labelId = `enhanced-table-checkbox-${index}`;
                  let variantName = row.productName;
                  if (row.featureValues) {
                    for (let i = 0; i <= 2 && row?.featureValues[i]; i++) {
                      variantName = variantName.concat(
                        ' - ',
                        row.featureValues[i].featureName,
                        ' : ',
                        row.featureValues[i].valueName,
                      );
                    }
                  }

                  if (row.sellerName || row.providerName) {
                    const sellerName = row.sellerName ?? row.providerName;
                    variantName = variantName.concat(' ( ', sellerName, ' )');
                  }

                  return (
                    <StyledTableRow key={index} hover tabIndex={-1} >
                      {/* <TableCell>
                        <Icon
                          path={
                            row.status === 'LOCATED'
                              ? mdiCheckBoxOutline
                              : mdiSquareOutline
                          }
                          size={1}
                          color={theme.palette.green.main}
                        />
                      </TableCell> */}
                      <TableCell id={labelId} scope="row" align="left" style={{ fontSize: '12px' }}>
                        <p>

                          {variantName}
                        </p>
                        <p></p>
                        <p>
                          <span style={{ fontWeight: 'bold' }}>شناسه تنوع: </span>{row.variantId}
                        </p>
                        <p>
                          وضعیت: {translate(row.status, 'parcel')}
                        </p>
                        <p>
                          یونیت: {row.unitBarcode} ({row.unitCode})
                        </p>

                      </TableCell>
                      {/* <TableCell id={labelId} scope="row" align="center">
                        {row.productCode}
                      </TableCell>
                      <TableCell id={labelId} scope="row" align="center">
                        {row.variantCode}
                      </TableCell>
                      <TableCell id={labelId} scope="row" align="center">
                        {row.serialNumber}
                      </TableCell>
                      <TableCell id={labelId} scope="row" align="center">
                        {row.unitBarcode}
                      </TableCell>{' '}
                      <TableCell id={labelId} scope="row" align="center">
                        {row.unitCode}
                      </TableCell> */}
                      {/* <TableCell style={{ position: 'relative' }}  >
                        <IconButton
                          aria-label="details"
                          size="small"
                          title="جایگذاری با بارکد"
                          data-cy="details"
                          onClick={() => setOpenBarcode(row)}
                          disabled={props.operatorId === row.id}
                          style={{ position: 'absolute', bottom: '16px', left: '10px' }}
                        >
                          <Icon path={mdiFileTree} size={1} color="purple" />
                        </IconButton>
                      </TableCell> */}
                    </StyledTableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}
